import React from 'react'
import { Pressable, Text } from 'react-native'

import { chip } from '@ui-kit/components/Chip/styles'

import type { NativeProps } from './types'

const Chip = (props: NativeProps): JSX.Element => {
  const { container, text } = chip({
    isActive: props.isActive,
  })
  return (
    <Pressable key={props.id} testID={props.id} className={container()} onPress={props.onPress}>
      <Text className={text()}>{props.label}</Text>
    </Pressable>
  )
}

export default Chip
